module.exports = __webpack_public_path__ + "static/werewolf-mtg_afr-bab22a329ea11d5ae0d9a16be96ada5b.jpg";